import { ButtonTeamBillingPortal } from "@/components/team/button-team-billing-portal";
import { SupportMessage } from "@/components/layout-loading/support-message";
import { useTeams } from "@/contexts/teams-provider";
import { useTranslation } from "@/hooks/useTranslation";
import { Layout } from "@/Layout";
import { cn } from "@/lib/utils";

export const SetupPaymentFailedBillingPage = () => {
  const { teamSelected } = useTeams();
  const { t } = useTranslation();

  return (
    <Layout showNavMain={false} showNavSearch={false} navLinkToTheRoot={false}>
      <div className={cn("flex-col py-6 space-y-3 text-center")}>
        <h1 className="text-2xl font-bold text-primary">
          {t("setup.paymentFailedBilling.title")}
        </h1>
        <p
          dangerouslySetInnerHTML={{
            __html: t("setup.paymentFailedBilling.description", {
              teamName: teamSelected?.name || "",
            }),
          }}
        />
        <ButtonTeamBillingPortal
          text={t("setup.paymentFailedBilling.button")}
        />
        <SupportMessage />
      </div>
    </Layout>
  );
};
